import React from 'react';
import { Link } from 'react-router-dom';

const Back = () => <Link to="/" className="button-arrow-black back">Back to Home<img src="../img/svg/arrow-white.svg" alt="arrow"/></Link>

export default Back;